import styled from 'styled-components'
import {Field, Form} from 'formik'
import {P} from '../../styles'

export const FormContainer = styled(Form)`
  display: flex;
  gap: 6.25rem;
  margin-top: 6rem;
`

export const Input = styled.input`
  border: 0.2rem solid ${(props) => props.bgColor};
  font-size: 1.1rem;
  margin: 0.5em 0 1.5em;
  padding: 0.7em;
  width: 100%;

  &:focus {
    border-width: 0.25rem;
  }
`

export const Label = styled.label`
  font-weight: bolder;
  color: ${(props) => props.bgColor};
  display: flex;
  font-size: 1rem;
`
export const TicketsField = styled(Field)`
  border: 0.2rem solid ${(props) => props.bgColor};
  font-size: 1.1rem;
  margin: 0 0 1.5em 0;
  padding: 0.7em;
  width: 100%;

  flex-shrink: 2;

  &:focus {
    border-width: 0.25rem;
  }
`

export const Error = styled.span`
  color: #e26e2d;
`

export const Submit = styled.button`
  background: none;
  border: 0.2rem solid ${(props) => props.bgColor};
  color: ${(props) => props.bgColor};
  cursor: pointer;
  float: right;
  font-size: 1.1rem;
  font-weight: bolder;
  padding: 0.7em;
  margin: 1em 0 0;
  text-transform: uppercase;
`
export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  color: grey;
`
export const TicketsSelector = styled.div`
  flex-grow: 2;
`
export const PCol = styled(P)`
  margin: 0;
`
